module.exports = __webpack_public_path__ + "static/media/competition-analysis.bb46e11e.png";